// Source keys for useOrderEditing.setExtraSaveErrors. The setter is keyed by
// `source` so multiple independent async validators can contribute without
// clobbering each other; using these constants instead of inline string
// literals prevents silent typos that would clear or write to the wrong slot.
//
// Add a new key when introducing another async validator. The value text is
// the actual key stored in the hook's Map — keep it short, kebab-case, and
// unique across the application.

/** Mode/Terminal compatibility check on the Pro Detail Order Info tab. */
export const SAVE_ERROR_MODE_TERMINAL = 'mode-terminal';
